const TvQueryKeys = {
  liveShows: ["tv", "live-shows"] as const,
  channel: (statusId: string, channelId: number) =>
    ["tv", "channels", statusId, channelId] as const,
  channelPing: (channelId: number) =>
    ["tv", "channels", channelId, "ping"] as const,
  liveContentCarousel: ["tv", "live-content-carousel"] as const,
  channelStream: (id: string) => ["tv", "channel-stream", id] as const,
};

export { TvQueryKeys };
